import { css } from '@emotion/react';
import { useContext } from 'react';
import { AngularContext } from 'react-app';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { blue05 } from 'athena/styles/colors';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import prodPathReplace from 'shared/prod-path-rewrite';
import { highTide, primary } from 'styles/global_defaults/colors';
import { quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';


const PulseChecksInfoBox = () => {
  const styles = css`
    border-radius: ${quarterSpacing}px;
    background-color: ${blue05};

    .participant-experience-icon {
      color: ${primary};
    }

    a {
      color: ${highTide};
    }

    .participant-experience-image {
      img {
        max-width: 150px;
        border-radius: ${standardSpacing}px;
      }
    }
  `;

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { id } = mentoringProgram || {};
  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);
  const dataDownloadsLink = $state.href('mentoring-program-reporting', { programId: id });

  return (
    <div css={styles} className='d-flex w-100 p-3 col align-items-center mb-4'>
      <NvIcon icon='ideas' size='small' className='mr-2 participant-experience-icon' />
      <div>
        <div className='mr-2 black font-weight-bolder'>
          {t.MENTORING_PROGRAMS.SETTINGS.TABS.FEEDBACK_SETTINGS.PULSE_CHECKS_INFO.TITLE()}
        </div>
        <div className='mr-2 black font-italic'>
          {t.MENTORING_PROGRAMS.SETTINGS.TABS.FEEDBACK_SETTINGS.PULSE_CHECKS_INFO.DESCRIPTION(dataDownloadsLink)}
        </div>
      </div>
      <div className='participant-experience-image'>
        <img
          src={prodPathReplace('images/pulse-checks-illustration.png')}
          alt={t.MENTORING_PROGRAMS.SETTINGS.TABS.FEEDBACK_SETTINGS.PULSE_CHECKS_INFO.ALT_LABEL()}
        />
      </div>
    </div>
  );
};

export default PulseChecksInfoBox;
